/**
 * What kind of machine is this browser on.
 *
 * "when a external client logs in with a phone default the screen to the
 *  mobile view, however when the external client logs in using a pc or mac
 *  then default the view would be the default lab view not mobile"
 *
 * The collector app is a phone app — one column, big targets, a camera. The
 * full application is not. Sending the same person to the same place on both
 * is wrong in one direction or the other: a phone user dropped into the full
 * application is pinching and scrolling, and somebody at a 27-inch monitor
 * gets a single narrow column.
 *
 * TWO SIGNALS, AND IT WANTS BOTH. The User-Agent can be spoofed and desktop
 * browsers can be put in a phone emulation mode; `pointer: coarse` with a
 * narrow viewport describes the thing a finger is actually touching. A device
 * is treated as a phone when either says so, because the cost of being wrong
 * is a default somebody can click past, not a lock.
 */
const UA = () => (typeof navigator === 'undefined' ? '' : navigator.userAgent || '');

// Tablet first: an iPad says "Mobile/15E148 Safari" in the same breath as
// "iPad", so any phone pattern loose enough to catch mobile Safari catches
// every iPad with it.
const TABLET_RE = /\b(ipad|tablet|playbook|silk)\b|android(?!.*\bmobile\b)/i;
const PHONE_RE = /\b(iphone|ipod|windows phone|blackberry|bb10|opera mini)\b|android.*\bmobile\b|\bmobile\b.*safari/i;

export function deviceKind(ua = UA()) {
  if (TABLET_RE.test(ua)) return 'tablet';
  if (PHONE_RE.test(ua)) return 'phone';
  return 'desktop';
}

/** A hand-held screen: phone, or a tablet being used like one. */
export function isHandheld() {
  const kind = deviceKind();
  if (kind === 'phone') return true;
  if (kind === 'tablet') return true;
  try {
    // A touch screen AND a narrow window. Either alone is not enough: touch
    // laptops exist, and a narrow window on a desktop is just a narrow window.
    return window.matchMedia('(pointer: coarse)').matches
        && window.matchMedia('(max-width: 820px)').matches;
  } catch { return false; }
}

/** Can this browser capture its own screen? No mobile browser can. */
export function canShareScreen() {
  if (typeof navigator === 'undefined') return false;
  if (!navigator.mediaDevices
      || typeof navigator.mediaDevices.getDisplayMedia !== 'function') return false;
  return deviceKind() === 'desktop';
}

export default { deviceKind, isHandheld, canShareScreen };
